class StickyAtc {
  constructor(el) {
    this.el = el;
    this.sectionId = el.dataset.sectionId;
    this.position = el.dataset.position || 'top';

    this.mainForm = document.getElementById(`product-form-${this.sectionId}`);
    this.mainButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
    this.mainQtyInput =
      document.getElementById(`Quantity-${this.sectionId}`) ||
      this.mainForm?.querySelector('.quantity__input');

    if (!this.mainButton || !this.mainForm) return;

    this.variantEl = el.querySelector('[data-sticky-atc-variant]');
    this.priceEl = el.querySelector('[data-sticky-atc-price]');
    this.buttonEl = el.querySelector('[data-sticky-atc-button]');
    this.buttonTextEl = el.querySelector('[data-sticky-atc-button-text]');
    this.spinnerEl = el.querySelector('.loading__spinner');
    this.stickyQtyWrapper = el.querySelector('[data-sticky-atc-qty-input]');
    this.stickyQtyInput = this.stickyQtyWrapper?.querySelector('.quantity__input');

    this.setupObserver();
    this.setupQuantitySync();
    this.setupVariantListener();
    this.setupLoadingState();
  }

  setupObserver() {
    const observer = new IntersectionObserver(
      ([entry]) => {
        const buttonVisible = entry.isIntersecting;
        this.el.classList.toggle('is-visible', !buttonVisible);
        this.el.setAttribute('aria-hidden', buttonVisible ? 'true' : 'false');
        this.updateBackToTopOffset(!buttonVisible);
      },
      { threshold: 0 }
    );
    observer.observe(this.mainButton);
  }

  updateBackToTopOffset(stickyVisible) {
    if (this.position !== 'bottom') return;
    const offset = stickyVisible ? `${this.el.offsetHeight}px` : '0px';
    document.documentElement.style.setProperty('--sticky-atc-offset', offset);
  }

  setupQuantitySync() {
    if (!this.stickyQtyInput || !this.mainQtyInput) return;

    // sticky → main
    this.stickyQtyInput.addEventListener('change', () => {
      this.mainQtyInput.value = this.stickyQtyInput.value;
      this.mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
    });

    // main → sticky
    this.mainQtyInput.addEventListener('change', () => {
      this.stickyQtyInput.value = this.mainQtyInput.value;
    });
  }

  setupVariantListener() {
    if (typeof subscribe === 'undefined') return;

    subscribe('variant-change', ({ data }) => {
      if (data.sectionId !== this.sectionId) return;

      const { variant } = data;

      if (!variant) {
        this.setUnavailable();
        return;
      }

      if (this.variantEl) {
        this.variantEl.textContent = variant.title === 'Default Title' ? '' : variant.title;
      }

      if (this.priceEl) {
        this.priceEl.textContent = this.formatMoney(variant.price);
      }

      // Sync quantity rules
      if (this.stickyQtyInput) {
        this.stickyQtyInput.min = variant.quantity_rule?.min ?? 1;
        this.stickyQtyInput.step = variant.quantity_rule?.increment ?? 1;
        if (variant.quantity_rule?.max) {
          this.stickyQtyInput.max = variant.quantity_rule.max;
        } else {
          this.stickyQtyInput.removeAttribute('max');
        }
        this.stickyQtyInput.value = this.mainQtyInput?.value ?? variant.quantity_rule?.min ?? 1;
      }

      if (variant.available) {
        this.buttonEl?.removeAttribute('disabled');
        if (this.buttonTextEl) {
          this.buttonTextEl.textContent = this.buttonEl?.dataset.addText || '';
        }
      } else {
        this.setUnavailable();
      }
    });
  }

  setupLoadingState() {
    this.mainForm.addEventListener('submit', () => {
      if (!this.buttonEl || !this.spinnerEl) return;
      this.buttonEl.setAttribute('aria-disabled', 'true');
      this.buttonEl.classList.add('loading');
      this.spinnerEl.classList.remove('hidden');
    });

    const reset = () => {
      if (!this.buttonEl || !this.spinnerEl) return;
      this.buttonEl.classList.remove('loading');
      this.spinnerEl.classList.add('hidden');
      if (this.buttonEl.getAttribute('aria-disabled') === 'true') {
        this.buttonEl.removeAttribute('aria-disabled');
      }
    };

    if (typeof subscribe !== 'undefined') {
      subscribe('cart-update', reset);
      subscribe('cart-error', reset);
    }
  }

  setUnavailable() {
    this.buttonEl?.setAttribute('disabled', '');
    if (this.buttonTextEl) {
      this.buttonTextEl.textContent = window.variantStrings?.soldOut || '';
    }
  }

  formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.moneyFormat || '{{amount_with_comma_separator}}');
    }
    return (cents / 100).toFixed(2);
  }
}

document.querySelectorAll('.sticky-atc').forEach((el) => new StickyAtc(el));
